<template>
  <v-card :color="'rgb(255, 255, 255)'" class="elevation-0 mx-0 mt-4">
    <v-toolbar dense flat>
      <v-toolbar-title>
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-data-table dense hide-default-footer :headers="headers" :items="filasGeneral"
        :server-items-length="filasGeneral.length" class="elevation-1 alternating-rows bordered-table">
        <template v-slot:[`item.fecha`]="{ item }">
          <v-menu v-if="item.esServicio && item.fechaEditable"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
            :value="Boolean(item._showFechaServicio)"
            @input="value => $set(item, '_showFechaServicio', value)">
            <template v-slot:activator="{ on }">
              <v-text-field class="ma-0 pa-0"
                dense
                outlined
                hide-details
                prepend-inner-icon="mdi-calendar"
                :value="getFechaServicioMostrada(item)"
                readonly
                clearable
                v-on="on"
                @click:clear="onLimpiarFechaServicio(item)"></v-text-field>
            </template>
            <v-date-picker color="success" locale="es"
              :value="getFechaServicioParaPicker(item)"
              @input="valor => onInputFechaServicio(item, valor)"
              first-day-of-week="1"></v-date-picker>
          </v-menu>
          <span v-else>{{ item.fecha }}</span>
        </template>
        <template v-slot:[`item.alojamiento`]="{ item }">
          <v-text-field v-if="item.esServicioExtra"
            v-model="item.servicio.proveedor_nota"
            class="ma-0 pa-0"
            dense
            hide-details
            outlined
            @blur="onGuardarProveedorNotaServicio(item)"
            @keyup.enter="onGuardarProveedorNotaServicio(item)"></v-text-field>
          <v-combobox v-else-if="item.esServicio && Array.isArray(item.proveedores_servicio)"
            v-model="item.servicio.proveedor" @change="onGuardarProveedorServicio(item)"
            @click:clear="onLimpiarProveedorServicio(item)" :items="item.proveedores_servicio"
            item-text="nombre_alias" item-value="id" return-object class="ma-0 pa-0" dense hide-details
            outlined clearable></v-combobox>
          <v-text-field v-else-if="item.esServicio && typeof item.proveedores_servicio === 'string'"
            :value="item.proveedores_servicio" class="ma-0 pa-0" dense hide-details outlined
            readonly></v-text-field>
          <span v-else>{{ item.alojamiento }}</span>
        </template>
        <template v-slot:[`item.descripcion`]="{ item }">
          {{ item.descripcion }}
        </template>
        <template v-slot:[`item.venta`]="{ item }">
          <span>{{ formatearImporteTabla(item.venta) }}</span>
        </template>
        <template v-slot:[`item.coste`]="{ item }">
          <v-text-field v-if="item.esServicio" v-model="item.servicio.coste"
            class="ma-0 pa-0 coste-text-field" dense hide-details type="text" outlined
            @blur="onGuardarCosteServicio(item)"
            @keyup.enter="onGuardarCosteServicio(item)"></v-text-field>
          <span v-else>{{ formatearImporteTabla(item.coste) }}</span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-menu v-if="mostrarAccionesFila(item)" bottom left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small v-bind="attrs" v-on="on">
                <v-icon small>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item v-for="accion in getAccionesFila(item)" :key="accion.key" @click="onAccionFila(item, accion.key)">
                <v-list-item-title>{{ accion.label }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:no-data>
          No hay etapas para mostrar
        </template>
         <template v-slot:body.append>
          <tr v-if="reserva">
            <td colspan="4" class="text-right font-weight-bold">Venta Total</td>
            <td class="text-right font-weight-bold">{{ formatearImporte(totalVenta) }}</td>
            <td> </td>
          </tr>
          <tr v-if="reserva">
            <td colspan="4" class="text-right font-weight-bold">Coste Total</td>
            <td class="text-right font-weight-bold">{{ formatearImporte(totalCoste) }}</td>

          </tr>
          <tr v-if="reserva">
            <td colspan="4" class="text-right font-weight-bold">Margen</td>
            <td class="text-right font-weight-bold">{{ formatearImporte(gananciaTotal) }}</td>
            <td> </td>
          </tr>
          <tr v-if="reserva">
            <td colspan="4" class="text-right font-weight-bold">Margen (%)</td>
            <td class="text-right font-weight-bold">{{ porcientoVentaCoste.toFixed(2) }} %</td>
            <td> </td>
          </tr>
        </template>
      </v-data-table>

      <v-dialog v-if="modelProveedor" v-model="dialogFormularioProveedor" width="1600px" persistent>
        <proveedor-formulario
          :modelProveedor="modelProveedor"
          :accion="'editar'"
          @cerrarFormularioProveedor="cerrarDialogProveedor"
        />
      </v-dialog>

      <v-dialog v-model="showDialogTarifasAlojamiento" max-width="900px" persistent>
        <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
          <v-toolbar dense flat color="blue-grey darken-3" dark>
            <v-toolbar-title>
              <span>Tarifas del Proveedor</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-icon size="30" color="white" @click="cerrarDialogTarifasAlojamiento">mdi-close-circle</v-icon>
          </v-toolbar>
          <v-card-text>
            <v-row dense class="mt-6 mx-4">
              <v-col cols="12" md="6">
                <v-text-field
                  :value="tarifasAlojamientoProveedor"
                  label="Proveedor"
                  outlined
                  dense
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-menu
                  v-model="menuFechaTarifasAlojamiento"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="tarifasAlojamientoFechaMostrada"
                      label="Fecha"
                      outlined
                      dense
                      readonly
                      prepend-inner-icon="mdi-calendar"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    :value="tarifasAlojamientoFecha"
                    color="success"
                    locale="es"
                    first-day-of-week="1"
                    @input="onCambiarFechaTarifasAlojamiento"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-row v-if="loadingTarifasAlojamiento" class="mx-4 my-8" justify="center">
              <v-progress-linear color="blue-grey darken-3" indeterminate rounded height="6"></v-progress-linear>
            </v-row>

            <v-row v-else-if="!tarifasAlojamiento.length" class="mx-4 my-8">
              <v-col cols="12" class="text-center">
                No existen tarifas para este proveedor y esta fecha
              </v-col>
            </v-row>

            <v-row v-else class="mx-4 mb-6">
              <v-col cols="12">
                <v-data-table
                  dense
                  hide-default-footer
                  :headers="headersTarifasDialogo"
                  :items="tarifasAlojamiento"
                  :items-per-page="tarifasAlojamiento.length"
                  class="elevation-1 alternating-rows bordered-table"
                >
                  <template v-slot:[`item.precio`]="{ item }">
                    {{ formatearImporte(item.precio) }}
                  </template>

                  <template v-slot:no-data>
                    No existen tarifas para este proveedor y esta fecha
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showDialogEnviarCorreoServicio" max-width="800px" persistent>
        <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
          <v-toolbar dense flat color="blue-grey darken-3" dark>
            <v-toolbar-title>
              <span>Enviar Correo al Proveedor</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-icon size="30" color="white" @click="cerrarDialogEnviarCorreoServicio">mdi-close-circle</v-icon>
          </v-toolbar>
          <v-card-text>
            <v-row dense class="mt-6 mx-4">
              <v-select
                v-model="enviarCorreoServicioDe"
                :items="enviarCorreoServicioListaCorreos"
                label="De"
                outlined
                dense
              ></v-select>
            </v-row>

            <v-row dense class="mx-4">
              <v-select
                v-model="enviarCorreoServicioPara"
                :items="enviarCorreoServicioParaOptions"
                label="Para"
                outlined
                dense
                clearable
                no-data-text="No hay correos disponibles para este proveedor"
              ></v-select>
            </v-row>

            <v-row dense class="mx-4">
              <v-text-field
                v-model="enviarCorreoServicioCC"
                label="CC"
                outlined
                dense
                autocomplete="off"
              ></v-text-field>
            </v-row>

            <v-row dense class="mx-4">
              <v-text-field
                v-model="enviarCorreoServicioAsunto"
                label="Asunto"
                outlined
                dense
                autocomplete="off"
              ></v-text-field>
            </v-row>

            <v-row dense class="mx-4">
              <texto-correo-editor
                v-model="enviarCorreoServicioTexto"
                estilo-proveedor
                label="Texto del Correo"
                outlined
                dense
                rows="10"
                autocomplete="off"
              ></texto-correo-editor>
            </v-row>

            <v-row class="mx-4 mb-2 mt-8">
              <v-spacer></v-spacer>
              <v-chip
                class="mr-1 px-10"
                label
                color="blue-grey darken-3"
                text-color="white"
                link
                :disabled="!puedeEnviarCorreoServicio() || loadingEnviandoCorreoServicio"
                @click="enviarCorreoProveedorServicio"
              >
                <span v-if="loadingEnviandoCorreoServicio" style="color: white;">Enviando...</span>
                <span v-else style="color: white;">Enviar Correo</span>
              </v-chip>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showDialogObservacionesBono" max-width="800px" persistent>
        <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
          <v-toolbar dense flat color="blue-grey darken-3" dark>
            <v-toolbar-title>
              <span>Observaciones Bono</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-icon size="30" color="white" @click="cerrarDialogObservacionesBono">mdi-close-circle</v-icon>
          </v-toolbar>
          <v-card-text>
            <v-row dense class="mt-6 mx-4">
              <v-text-field
                :value="servicioObservacionesSeleccionado ? (servicioObservacionesSeleccionado.titulo || observacionesBonoTitulo) : observacionesBonoTitulo"
                label="Servicio"
                outlined
                dense
                readonly
              ></v-text-field>
            </v-row>

            <v-row dense class="mx-4">
              <v-textarea
                v-model="observacionesBonoDescripcion"
                label="Descripción / Observaciones"
                outlined
                dense
                rows="8"
                autocomplete="off"
              ></v-textarea>
            </v-row>

            <v-row dense class="mx-4">
              <v-col cols="12" class="px-0 pt-0">
                <div class="d-flex justify-end">
                  <v-chip
                    small
                    label
                    color="blue-grey lighten-4"
                    :disabled="!observacionesBonoProveedorTexto"
                    @click="mostrarObservacionesProveedorBono = !mostrarObservacionesProveedorBono"
                  >
                    {{ mostrarObservacionesProveedorBono ? "Ocultar obs. proveedor" : "Ver obs. proveedor" }}
                  </v-chip>
                </div>
              </v-col>
            </v-row>

            <v-row v-if="mostrarObservacionesProveedorBono" dense class="mx-4">
              <v-textarea
                :value="observacionesBonoProveedorTexto"
                label="Observaciones Bono del Proveedor"
                outlined
                dense
                rows="4"
                readonly
                autocomplete="off"
              ></v-textarea>
            </v-row>

            <v-row class="mx-4 mb-2 mt-8">
              <v-spacer></v-spacer>
              <v-chip
                class="mr-1 px-10"
                label
                color="blue-grey darken-3"
                text-color="white"
                link
                :disabled="loadingGuardandoObservacionesBono"
                @click="guardarObservacionesBono"
              >
                <span v-if="loadingGuardandoObservacionesBono" style="color: white;">Guardando...</span>
                <span v-else style="color: white;">Guardar</span>
              </v-chip>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card-text>
  </v-card>
</template>

<script>
import TextoCorreoEditor from "@/components/correos/TextoCorreoEditor.vue";
import ProveedorFormulario from "@/components/formularios/ProveedorFormulario.vue";
import {
  descripcionCosteEtapa,
  formatearImporte,
  getCosteEtapa,
  getGananciaResumen,
  getPorcentajeVentaCoste,
  getTotalCosteResumen,
  getTotalVentaResumen,
} from "@/helpers/reservaHelpers";
import { formatearFechaCorta } from "@/helpers/dateHelpers";
import { mapState, mapActions } from "vuex";

export default {
  name: "VistaResumen",
  components: {
    TextoCorreoEditor,
    ProveedorFormulario,
  },
  props: {
    reserva: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    headers: [
      { text: "Fecha", value: "fecha", align: "left", width: "200px" },
      { text: "Proveedor", value: "alojamiento", align: "left" },
      { text: "Descripcion", value: "descripcion", align: "left" },
      { text: "Venta", value: "venta", align: "right" },
      { text: "Coste", value: "coste", align: "right" },
      { text: "", value: "actions", align: "center", sortable: false, width: "0%", class: "actions-column", cellClass: "actions-column" },
    ],
    showDialogEnviarCorreoServicio: false,
    loadingEnviandoCorreoServicio: false,
    servicioCorreoSeleccionado: null,
    proveedorCorreoSeleccionado: null,
    enviarCorreoServicioListaCorreos: [],
    enviarCorreoServicioDe: "",
    enviarCorreoServicioParaOptions: [],
    enviarCorreoServicioPara: "",
    enviarCorreoServicioCC: "",
    enviarCorreoServicioAsunto: "",
    enviarCorreoServicioTexto: "",
    dialogFormularioProveedor: false,
    modelProveedor: null,
    headersTarifasAlojamiento: [
      { text: "Régimen", value: "regimen" },
      { text: "Habitación - Característica", value: "habitacion_caracteristica" },
      { text: "Precio", value: "precio", align: "right" },
    ],
    headersTarifasGenericas: [
      { text: "Descripción", value: "descripcion" },
      { text: "Unidad", value: "unidad" },
      { text: "Precio", value: "precio", align: "right" },
    ],
    showDialogTarifasAlojamiento: false,
    loadingTarifasAlojamiento: false,
    tarifasAlojamiento: [],
    tarifasAlojamientoProveedorId: null,
    tarifasAlojamientoProveedor: "",
    tarifasAlojamientoFecha: "",
    menuFechaTarifasAlojamiento: false,
    tipoTarifasDialogo: "alojamiento",
    showDialogObservacionesBono: false,
    loadingGuardandoObservacionesBono: false,
    servicioObservacionesSeleccionado: null,
    itemObservacionesSeleccionado: null,
    observacionesBonoTitulo: "",
    observacionesBonoDescripcion: "",
    mostrarObservacionesProveedorBono: false,
  }),
  computed: {
     ...mapState("auth", ["access_token", "user", "masterProveedores"]),
    ...mapState("proveedores", ["proveedores", "proveedoresServiciosPaqueterias", "proveedoresServiciosGuias", "proveedoresServiciosBodegas", "proveedoresServiciosSeguros", "proveedoresServiciosTransfers", "proveedoresServiciosExcursiones"]),

    observacionesBonoProveedorTexto() {
      const proveedor = this.getProveedorObservacionesBono();
      return String(proveedor?.observaciones_bono || "").trim();
    },

    filaReserva() {
      if (!this.reserva) {
        return null;
      }
      return {
        fecha: formatearFechaCorta(this.reserva.fecha_inicio) + " - " + formatearFechaCorta(this.reserva.fecha_llegada),
        alojamiento: "RUTAS MEIGAS",
        descripcion: this.reserva.camino.titulo || "",
        venta: this.reserva.importe_presupuestado,
        coste: "0.00 €",
      };
    },

    filaEnBlanco() {
      return {
        fecha: "",
        alojamiento: "",
        descripcion: "",
        venta: "",
        coste: "",
      };
    },

    filasEtapas() {
      const etapas = Array.isArray(this.reserva?.etapas) ? this.reserva.etapas : [];
      return etapas.flatMap((etapa) => {
        const proveedor = etapa?.pivot?.proveedor_nombre;
        if (!proveedor || etapa?.pivot?.estado_id !== 5) {
          return [];
        }
        const coste = getCosteEtapa(this.reserva, etapa);
        const proveedorEtapa = this.getProveedorEtapaDesdeEtapa(etapa);
        return [
          {
            fecha: formatearFechaCorta(etapa?.pivot?.fecha || etapa?.fecha),
            alojamiento: proveedor,
            descripcion: descripcionCosteEtapa(this.reserva, etapa) || "",
            esEtapa: true,
            etapa,
            proveedorEtapa,
            mostrarAcciones: true,
            venta: "0.00 €",
            coste: `${coste} €`,
            costeValor: Number(coste) || 0,
          },
        ];
      });
    },


    filaServicios() {
      if (!this.reserva) {
        return [];
      }
      const servicios = Array.isArray(this.reserva?.servicios) ? this.reserva.servicios : [];
      const filas = [];
      const servicioTransporteEquipaje = servicios.find((servicio) => {
        const titulo = servicio?.titulo || "";
        return titulo.startsWith("Transporte de equipaje") && servicio?.esta_incluido == 1;
      });
      
      if (servicioTransporteEquipaje) {
        const proveedorSeleccionado = this.getProveedorSeleccionado(
          servicioTransporteEquipaje,
          this.proveedoresServiciosPaqueterias
        );
        if (proveedorSeleccionado) {
          servicioTransporteEquipaje.proveedor = proveedorSeleccionado;
        }
        filas.push({
          fecha: this.getFechasServicioTraslado(this.reserva),
          alojamiento: "Proveedor:",
          proveedores_servicio: this.getProveedoresConSeleccionado(
            this.proveedoresServiciosPaqueterias,
            proveedorSeleccionado
          ),
          descripcion: "Traslado de Equipaje",
          esServicio: true,
          mostrarAcciones: true,
          venta: "0.00 €",
          coste: servicioTransporteEquipaje.coste,
          servicio: servicioTransporteEquipaje,
        });
      }
      const servicioVisitaGuia = servicios.find((servicio) => {
        const titulo = servicio?.titulo || "";
        return titulo.startsWith("Visita con Guía") && servicio?.esta_incluido == 1;
      });
      if (servicioVisitaGuia) {
        const proveedorSeleccionado = this.getProveedorSeleccionado(
          servicioVisitaGuia,
          this.proveedoresServiciosGuias
        );
        if (proveedorSeleccionado) {
          servicioVisitaGuia.proveedor = proveedorSeleccionado;
        }
        filas.push({
          fecha: null,
          alojamiento: "Proveedor:",
          proveedores_servicio: this.getProveedoresConSeleccionado(
            this.proveedoresServiciosGuias,
            proveedorSeleccionado
          ),
          descripcion: "Visita Guiada por el casco histórico de Santiago",
          esServicio: true,
          mostrarAcciones: true,
          fechaEditable: true,
          venta: "0.00 €",
          coste: servicioVisitaGuia.coste ?? "0",
          servicio: servicioVisitaGuia,
        });
      }

      const servicioDegustacionQueso = servicios.find((servicio) => {
        const titulo = servicio?.titulo || "";
        return titulo.startsWith("Degustación de quesos") && servicio?.esta_incluido == 1;
      });
      if (servicioDegustacionQueso) {
        const proveedorSeleccionado = this.getProveedorSeleccionado(
          servicioDegustacionQueso,
          this.proveedoresServiciosBodegas
        );
        if (proveedorSeleccionado) {
          servicioDegustacionQueso.proveedor = proveedorSeleccionado;
        }
        filas.push({
          fecha: null,
          alojamiento: "Proveedor:",
          proveedores_servicio: this.getProveedoresConSeleccionado(
            this.proveedoresServiciosBodegas,
            proveedorSeleccionado
          ),
          descripcion: "Degustación de quesos gallegos en Santiago",
          esServicio: true,
          mostrarAcciones: true,
          fechaEditable: true,
          venta: "0.00 €",
          coste: servicioDegustacionQueso.coste ?? "0",
          servicio: servicioDegustacionQueso,
        });
      }

      const servicioSeguroViaje = servicios.find((servicio) => {
        const titulo = servicio?.titulo || "";
        return titulo.startsWith("Seguro de viaje") && servicio?.esta_incluido == 1;
      });
      if (servicioSeguroViaje) {
        const proveedorSeleccionado = this.getProveedorSeleccionado(
          servicioSeguroViaje,
          this.proveedoresServiciosSeguros
        );
        if (proveedorSeleccionado) {
          servicioSeguroViaje.proveedor = proveedorSeleccionado;
        }
        filas.push({
          fecha: formatearFechaCorta(this.reserva.fecha_inicio) + " - " + formatearFechaCorta(this.reserva.fecha_llegada),
          alojamiento: "Proveedor:",
          proveedores_servicio: this.getProveedoresConSeleccionado(
            this.proveedoresServiciosSeguros,
            proveedorSeleccionado
          ),
          descripcion: "Seguro de viaje",
          esServicio: true,
          mostrarAcciones: true,
          venta: "0.00 €",
          coste: servicioSeguroViaje.coste ?? "0",
          servicio: servicioSeguroViaje,
        });
      }

      return filas;

    },

    filaServiciosAgregados() {
      if (!this.reserva) {
        return [];
      }
      const servicios = Array.isArray(this.reserva?.servicios) ? this.reserva.servicios : [];
      const filas = [];

      this.addServiciosAgregadosDeTraslados(servicios, filas);
      this.addServiciosAgregadosDeExcursiones(servicios, filas);
      this.addServiciosAgregadosDeSeguro(servicios, filas);
      this.addServiciosAgregadosDeServiciosExtra(servicios, filas);

      return filas;
    },


    filasGeneral() {
      if (!this.reserva) {
        return [];
      }
      //const filasEtapas = this.filasEtapas.map(({ costeValor, ...fila }) => fila);
      return [
        this.filaReserva,
        this.filaEnBlanco,
        ...this.filasEtapas,
        this.filaEnBlanco,
        ...this.filaServicios,
        this.filaEnBlanco,
        ...this.filaServiciosAgregados,
        this.filaEnBlanco,
      ];
    },

    


    totalVenta() {
      return getTotalVentaResumen(this.reserva);
    },
    totalCoste() {
      return getTotalCosteResumen(this.reserva);
    },
    porcientoVentaCoste() {
      return getPorcentajeVentaCoste(this.reserva);
    },
    gananciaTotal() {
      return getGananciaResumen(this.reserva);
    },
    tarifasAlojamientoFechaMostrada() {
      if (!this.tarifasAlojamientoFecha) {
        return "";
      }
      return formatearFechaCorta(this.tarifasAlojamientoFecha);
    },
    headersTarifasDialogo() {
      if (this.tarifasAlojamiento.some((tarifa) => tarifa?.descripcion != null || tarifa?.unidad != null)) {
        return this.headersTarifasGenericas;
      }
      if (
        this.tarifasAlojamiento.some(
          (tarifa) => tarifa?.regimen != null || tarifa?.habitacion_caracteristica != null || tarifa?.precio != null
        )
      ) {
        return this.headersTarifasAlojamiento;
      }
      return this.tipoTarifasDialogo === "servicio"
        ? this.headersTarifasGenericas
        : this.headersTarifasAlojamiento;
    },
  },

  mounted() {
    console.log('ReservaDDesdeResumen:', this.reserva);

  },

  methods: {

    ...mapActions("reservas", ["updateReservaServicioCoste", "updateReservaServicioProveedor", "updateReservaServicioFecha", "enviarCorreo", "updateReservaServicioDescripcion", "generarBonoServicioIndividual", "generarBonoAlojamientoIndividual"]),
    ...mapActions("proveedores", ["getMaestrasProveedores", "getProveedor", "getTarifasProveedorPorFecha"]),

    formatearImporte,

    formatearImporteTabla(valor) {
      if (valor === null || valor === undefined || valor === "") {
        return "";
      }

      return this.formatearImporte(valor);
    },

    async onGuardarCosteServicio(item) {
      if (!item?.servicio) {
        return;
      }
      const res = await this.updateReservaServicioCoste([this.access_token, item.servicio.reserva_id, item.servicio.servicio_id, item.coste]);
      if (res && res.id == this.reserva.id) {
        this.reserva.servicios = res.servicios;
      }

    },

    mostrarAccionesFila(item) {
      if (item?.esEtapa) {
        return this.etapaTieneProveedor(item);
      }
      if (item?.esServicio) {
        return this.servicioTieneProveedor(item);
      }
      return Boolean(item?.mostrarAcciones);
    },

    servicioTieneProveedor(item) {
      if (!item?.servicio) {
        return false;
      }

      if (item.esServicioExtra) {
        return Boolean(
          String(item.servicio?.proveedor_nota || item.proveedores_servicio || "").trim()
        );
      }

      const proveedor = item.servicio?.proveedor;
      if (typeof proveedor === "string" && proveedor.trim()) {
        return true;
      }
      if (
        proveedor &&
        typeof proveedor === "object" &&
        (proveedor.id || proveedor.nombre_alias || proveedor.nombre)
      ) {
        return true;
      }

      if (item.servicio?.proveedor_id) {
        return true;
      }

      if (String(item.servicio?.proveedor_nombre || "").trim()) {
        return true;
      }

      if (typeof item.proveedores_servicio === "string" && item.proveedores_servicio.trim()) {
        return true;
      }

      return false;
    },

    etapaTieneProveedor(item) {
      if (!item?.esEtapa) {
        return false;
      }
      return Boolean(
        this.getProveedorEtapa(item)?.id ||
        String(item?.etapa?.pivot?.proveedor_nombre || item?.alojamiento || "").trim()
      );
    },

    getAccionesFila(item) {
      if (item?.esEtapa) {
        const acciones = [
          { key: "enviar_correo_etapa", label: "Enviar Correo" },
        ];
        if (this.getIdReservaEtapaProveedor(item?.etapa)) {
          acciones.push({ key: "generar_bono_alojamiento_individual", label: "Generar Bono Individual" });
        }
        if (this.getProveedorEtapa(item)?.id) {
          acciones.push({ key: "ver_tarifas_alojamiento", label: "Ver Tarifas" });
          acciones.push({ key: "ver_ficha_alojamiento", label: "Ver Ficha del Proveedor" });
        }
        return acciones;
      }
      if (item?.esServicio) {
        const acciones = [{ key: "enviar_correo_servicio", label: "Enviar Correo" }];
        if (this.getProveedorServicio(item)?.id) {
          acciones.push({ key: "ver_tarifas_servicio", label: "Ver Tarifas" });
          acciones.push({ key: "ver_ficha_alojamiento", label: "Ver Ficha del Proveedor" });
        }
        if (this.getIdReservaServicio(item?.servicio)) {
          acciones.push({ key: "generar_bono_individual", label: "Generar Bono Individual" });
        }
        acciones.push({ key: "observaciones_bono", label: "Observaciones Bono" });
        return acciones;
      }
      return [];
    },

    onAccionFila(item, accion) {
      if (accion === "enviar_correo_etapa") {
        this.onEnviarCorreoServicio(item);
        return;
      }
      if (accion === "ver_ficha_alojamiento") {
        this.onVerFichaAlojamiento(item);
        return;
      }
      if (accion === "ver_tarifas_alojamiento") {
        this.onVerTarifasAlojamiento(item);
        return;
      }
      if (accion === "generar_bono_alojamiento_individual") {
        this.onGenerarBonoAlojamientoIndividual(item);
        return;
      }
      if (accion === "ver_tarifas_servicio") {
        this.onVerTarifasServicio(item);
        return;
      }
      if (accion === "enviar_correo_servicio") {
        this.onEnviarCorreoServicio(item);
        return;
      }
      if (accion === "generar_bono_individual") {
        this.onGenerarBonoServicioIndividual(item);
        return;
      }
      if (accion === "observaciones_bono") {
        this.onObservacionesBono(item);
      }
    },

    getListaCorreosUsuario() {
      const correos = [];
      if (this.user?.email) {
        correos.push(this.user.email);
      }
      if (this.user?.lista_emails) {
        correos.push(...this.user.lista_emails.split(";"));
      }
      return [...new Set(correos.map((email) => String(email || "").trim()).filter(Boolean))];
    },

    getProveedorEtapaDesdeEtapa(etapa) {
      const proveedorId = etapa?.pivot?.proveedor_id;
      const proveedorNombre = etapa?.pivot?.proveedor_nombre;

      if (!proveedorId && !proveedorNombre) {
        return null;
      }

      const proveedorListado = Array.isArray(this.proveedores) ? this.proveedores : [];
      const proveedorStore = proveedorListado.find((proveedor) => proveedor.id == proveedorId);
      if (proveedorStore) {
        return proveedorStore;
      }

      const proveedorMaster = Array.isArray(this.masterProveedores)
        ? this.masterProveedores.find((proveedor) => proveedor.id == proveedorId)
        : null;
      if (proveedorMaster) {
        return proveedorMaster;
      }

      return {
        id: proveedorId ?? null,
        nombre_alias: proveedorNombre || "",
        nombre: proveedorNombre || "",
      };
    },

    getProveedorEtapa(item) {
      if (!item?.esEtapa) {
        return null;
      }

      if (item.proveedorEtapa && typeof item.proveedorEtapa === "object") {
        return item.proveedorEtapa;
      }

      return this.getProveedorEtapaDesdeEtapa(item.etapa);
    },

    getFechaEtapaIso(item) {
      const fecha = item?.etapa?.pivot?.fecha || item?.etapa?.fecha || "";
      if (/^\d{4}-\d{2}-\d{2}/.test(fecha)) {
        return fecha.slice(0, 10);
      }
      return "";
    },

    getFechaServicioIso(item) {
      const fechaServicio = this.getFechaServicioParaPicker(item);
      if (fechaServicio) {
        return fechaServicio;
      }
      return this.normalizarFechaServicio(this.reserva?.fecha_inicio || this.reserva?.fecha_llegada);
    },

    getProveedorServicio(item) {
      if (!item?.servicio) {
        return null;
      }
      if (item.servicio?.proveedor && typeof item.servicio.proveedor === "object") {
        return item.servicio.proveedor;
      }
      const listado = Array.isArray(item.proveedores_servicio) ? item.proveedores_servicio : [];
      const proveedorId = item.servicio?.proveedor_id;
      if (proveedorId) {
        return listado.find((proveedor) => proveedor.id == proveedorId) || null;
      }
      return null;
    },

    getProveedorFila(item) {
      if (item?.esEtapa) {
        return this.getProveedorEtapa(item);
      }
      if (item?.esServicio) {
        return this.getProveedorServicio(item);
      }
      return null;
    },

    getProveedorObservacionesBono() {
      const item = this.itemObservacionesSeleccionado;
      const proveedorFila = this.getProveedorFila(item);

      if (proveedorFila?.observaciones_bono != null) {
        return proveedorFila;
      }

      const proveedorId = proveedorFila?.id || item?.servicio?.proveedor_id || null;
      if (!proveedorId) {
        return proveedorFila;
      }

      const proveedorListado = Array.isArray(this.proveedores) ? this.proveedores : [];
      const proveedorStore = proveedorListado.find((proveedor) => proveedor.id == proveedorId);
      if (proveedorStore) {
        return proveedorStore;
      }

      const proveedorMaster = Array.isArray(this.masterProveedores)
        ? this.masterProveedores.find((proveedor) => proveedor.id == proveedorId)
        : null;

      return proveedorMaster || proveedorFila || null;
    },

    getNombreProveedorServicio(item, proveedor = null) {
      const proveedorServicio = proveedor || this.getProveedorFila(item);
      return (
        proveedorServicio?.nombre_alias ||
        proveedorServicio?.nombre ||
        item?.etapa?.pivot?.proveedor_nombre ||
        item?.servicio?.proveedor_nombre ||
        item?.servicio?.proveedor_nota ||
        item?.alojamiento ||
        ""
      );
    },

    getEmailsProveedorServicio(item, proveedor = null) {
      const proveedorServicio = proveedor || this.getProveedorFila(item);
      const correos = [];

      if (proveedorServicio?.email_reservas) {
        correos.push(...String(proveedorServicio.email_reservas).split(/[;,]/));
      }
      if (proveedorServicio?.email) {
        correos.push(...String(proveedorServicio.email).split(/[;,]/));
      }
      if (item?.servicio?.proveedor_email) {
        correos.push(...String(item.servicio.proveedor_email).split(/[;,]/));
      }
      if (item?.etapa?.pivot?.proveedor_email) {
        correos.push(...String(item.etapa.pivot.proveedor_email).split(/[;,]/));
      }

      return [...new Set(correos.map((email) => String(email || "").trim()).filter(Boolean))];
    },

    getAsuntoCorreoServicio(item, proveedor = null) {
      const proveedorNombre = this.getNombreProveedorServicio(item, proveedor);
      const codigo = this.reserva?.codigo || "";
      const descripcion = item?.esEtapa
        ? `Alojamiento - ${item?.alojamiento || proveedorNombre || ""}`.trim()
        : item?.descripcion || item?.servicio?.titulo || "Servicio";
      return [codigo, descripcion].filter(Boolean).join(" - ");
    },

    getTextoCorreoServicio(item, proveedor = null) {
      const proveedorNombre = this.getNombreProveedorServicio(item, proveedor);
      const descripcion = item?.esEtapa
        ? item?.alojamiento || "alojamiento"
        : item?.descripcion || item?.servicio?.titulo || "servicio";
      const tipo = item?.esEtapa ? "Alojamiento" : "Servicio";
      const fecha = item?.esServicio ? this.getFechaServicioMostrada(item) : (item?.fecha || "");
      const cliente = [this.reserva?.cliente?.nombre, this.reserva?.cliente?.apellidos]
        .filter(Boolean)
        .join(" ");
      const codigo = this.reserva?.codigo || "";

      return [
        proveedorNombre ? `Hola ${proveedorNombre},` : "Hola,",
        "",
        `Te contactamos por la reserva ${codigo}${cliente ? ` de ${cliente}` : ""}.`,
        fecha ? `Fecha: ${fecha}.` : "",
      ]
        .filter(Boolean)
        .join("\n");
    },

    puedeEnviarCorreoServicio() {
      return Boolean(
        this.enviarCorreoServicioDe &&
        this.enviarCorreoServicioPara &&
        this.enviarCorreoServicioAsunto
      );
    },

    cerrarDialogEnviarCorreoServicio() {
      this.showDialogEnviarCorreoServicio = false;
      this.loadingEnviandoCorreoServicio = false;
      this.servicioCorreoSeleccionado = null;
      this.proveedorCorreoSeleccionado = null;
      this.enviarCorreoServicioDe = "";
      this.enviarCorreoServicioParaOptions = [];
      this.enviarCorreoServicioPara = "";
      this.enviarCorreoServicioCC = "";
      this.enviarCorreoServicioAsunto = "";
      this.enviarCorreoServicioTexto = "";
      this.enviarCorreoServicioListaCorreos = [];
    },

    onEnviarCorreoServicio(item) {
      const proveedor = this.getProveedorFila(item);
      const correosUsuario = this.getListaCorreosUsuario();
      const correosProveedor = this.getEmailsProveedorServicio(item, proveedor);

      this.servicioCorreoSeleccionado = item;
      this.proveedorCorreoSeleccionado = proveedor;
      this.enviarCorreoServicioListaCorreos = correosUsuario;
      this.enviarCorreoServicioDe = correosUsuario[0] || this.user?.email || "";
      this.enviarCorreoServicioCC = this.user?.email || this.enviarCorreoServicioDe || "";
      this.enviarCorreoServicioParaOptions = correosProveedor;
      this.enviarCorreoServicioPara = correosProveedor[0] || "";
      this.enviarCorreoServicioAsunto = this.getAsuntoCorreoServicio(item, proveedor);
      this.enviarCorreoServicioTexto = this.getTextoCorreoServicio(item, proveedor);

      this.showDialogEnviarCorreoServicio = true;
      this.$emit("enviar-correo-servicio", item);
    },

    async onVerFichaAlojamiento(item) {
      const proveedor = this.getProveedorFila(item);
      if (!proveedor?.id) {
        return;
      }

      await this.getMaestrasProveedores([this.access_token, false]);
      const proveedorCompleto = await this.getProveedor([this.access_token, proveedor.id, false]);
      this.modelProveedor = JSON.parse(JSON.stringify(proveedorCompleto || proveedor));
      this.dialogFormularioProveedor = true;
    },

    cerrarDialogProveedor() {
      this.dialogFormularioProveedor = false;
      this.modelProveedor = null;
    },

    async onVerTarifasAlojamiento(item) {
      const proveedor = this.getProveedorEtapa(item);
      const fecha = this.getFechaEtapaIso(item);

      await this.abrirDialogTarifasProveedor(item, proveedor, fecha, "alojamiento");
    },

    async onVerTarifasServicio(item) {
      const proveedor = this.getProveedorServicio(item);
      const fecha = this.getFechaServicioIso(item);

      await this.abrirDialogTarifasProveedor(item, proveedor, fecha, "servicio");
    },

    async abrirDialogTarifasProveedor(item, proveedor, fecha, tipo) {

      if (!proveedor?.id || !fecha) {
        return;
      }

      this.loadingTarifasAlojamiento = true;
      this.tarifasAlojamiento = [];
      this.tarifasAlojamientoProveedorId = proveedor.id;
      this.tarifasAlojamientoProveedor = this.getNombreProveedorServicio(item, proveedor);
      this.tarifasAlojamientoFecha = fecha;
      this.tipoTarifasDialogo = tipo;
      this.showDialogTarifasAlojamiento = true;

      try {
        await this.cargarTarifasAlojamiento();
      } finally {
        this.loadingTarifasAlojamiento = false;
      }
    },

    async cargarTarifasAlojamiento() {
      if (!this.tarifasAlojamientoProveedorId || !this.tarifasAlojamientoFecha) {
        this.tarifasAlojamiento = [];
        return;
      }

      const response = await this.getTarifasProveedorPorFecha([
        this.access_token,
        this.tarifasAlojamientoProveedorId,
        this.tarifasAlojamientoFecha,
        false,
      ]);

      this.tarifasAlojamiento = Array.isArray(response?.tarifas) ? response.tarifas : [];
    },

    async onCambiarFechaTarifasAlojamiento(fecha) {
      this.tarifasAlojamientoFecha = fecha || "";
      this.menuFechaTarifasAlojamiento = false;
      this.loadingTarifasAlojamiento = true;

      try {
        await this.cargarTarifasAlojamiento();
      } finally {
        this.loadingTarifasAlojamiento = false;
      }
    },

    cerrarDialogTarifasAlojamiento() {
      this.showDialogTarifasAlojamiento = false;
      this.loadingTarifasAlojamiento = false;
      this.tarifasAlojamiento = [];
      this.tarifasAlojamientoProveedorId = null;
      this.tarifasAlojamientoProveedor = "";
      this.tarifasAlojamientoFecha = "";
      this.menuFechaTarifasAlojamiento = false;
      this.tipoTarifasDialogo = "alojamiento";
    },

    async enviarCorreoProveedorServicio() {
      if (!this.puedeEnviarCorreoServicio() || this.loadingEnviandoCorreoServicio) {
        return;
      }

      this.loadingEnviandoCorreoServicio = true;
      try {
        const res = await this.enviarCorreo([
          this.access_token,
          this.reserva.id,
          this.enviarCorreoServicioDe,
          this.enviarCorreoServicioPara,
          this.enviarCorreoServicioCC,
          this.enviarCorreoServicioAsunto,
          this.enviarCorreoServicioTexto,
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          null,
        ]);

        if (res && res.id == this.reserva.id) {
          this.$emit("correo-servicio-enviado", {
            item: this.servicioCorreoSeleccionado,
            proveedor: this.proveedorCorreoSeleccionado,
            reserva: res,
          });
        }

        this.cerrarDialogEnviarCorreoServicio();
      } finally {
        this.loadingEnviandoCorreoServicio = false;
      }
    },

    onObservacionesBono(item) {
      this.itemObservacionesSeleccionado = item || null;
      this.servicioObservacionesSeleccionado = item?.servicio || null;
      this.observacionesBonoTitulo = item?.descripcion || item?.servicio?.titulo || "";
      this.observacionesBonoDescripcion = item?.servicio?.descripcion || "";
      this.mostrarObservacionesProveedorBono = false;
      this.showDialogObservacionesBono = true;
      this.$emit("observaciones-bono", item);
    },

    cerrarDialogObservacionesBono() {
      this.showDialogObservacionesBono = false;
      this.loadingGuardandoObservacionesBono = false;
      this.servicioObservacionesSeleccionado = null;
      this.itemObservacionesSeleccionado = null;
      this.observacionesBonoTitulo = "";
      this.observacionesBonoDescripcion = "";
      this.mostrarObservacionesProveedorBono = false;
    },

    async guardarObservacionesBono() {
      const servicioId = this.getIdServicioReserva(this.servicioObservacionesSeleccionado);
      if (!servicioId || this.loadingGuardandoObservacionesBono) {
        return;
      }

      this.loadingGuardandoObservacionesBono = true;
      try {
        const res = await this.updateReservaServicioDescripcion([
          this.access_token,
          servicioId,
          this.observacionesBonoDescripcion,
        ]);

        if (res && res.id == this.reserva.id) {
          this.reserva.servicios = res.servicios;
        }

        this.cerrarDialogObservacionesBono();
      } finally {
        this.loadingGuardandoObservacionesBono = false;
      }
    },

    async onGenerarBonoServicioIndividual(item) {
      const reservaServicioId = this.getIdReservaServicio(item?.servicio);
      if (!reservaServicioId) {
        return;
      }

      const res = await this.generarBonoServicioIndividual([
        this.access_token,
        reservaServicioId,
      ]);

      if (res && res.id == this.reserva.id) {
        Object.assign(this.reserva, res);
        this.$emit("bono-servicio-individual-generado", {
          item,
          reserva: res,
        });
      }
    },

    async onGenerarBonoAlojamientoIndividual(item) {
      const reservaEtapaProveedorId = this.getIdReservaEtapaProveedor(item?.etapa);
      if (!reservaEtapaProveedorId) {
        return;
      }

      const res = await this.generarBonoAlojamientoIndividual([
        this.access_token,
        reservaEtapaProveedorId,
      ]);

      if (res && res.id == this.reserva.id) {
        Object.assign(this.reserva, res);
        this.$emit("bono-alojamiento-individual-generado", {
          item,
          reserva: res,
        });
      }
    },

    async onGuardarProveedorServicio(item) {
      if (!item?.servicio) {
        return;
      }
      const servicioId = this.getIdServicioReserva(item.servicio);
      if (!servicioId) {
        return;
      }
      const proveedorId = item.servicio?.proveedor ? item.servicio.proveedor.id : null;
      item.servicio.proveedor_id = proveedorId;
      console.log("item.servicio:", item.servicio);
      const res = await this.updateReservaServicioProveedor([this.access_token, servicioId, proveedorId]);
      console.log("res:", res);
      if (res && res.id == this.reserva.id) {
        this.reserva.servicios = res.servicios;
      }
    },

    async onGuardarProveedorNotaServicio(item) {
      if (!item?.servicio) {
        return;
      }
      const servicioId = this.getIdServicioReserva(item.servicio);
      if (!servicioId) {
        return;
      }
      const proveedorId = item.servicio?.proveedor_id ?? null;
      const proveedorNota = item.servicio?.proveedor_nota || "";
      const res = await this.updateReservaServicioProveedor([
        this.access_token,
        servicioId,
        proveedorId,
        proveedorNota,
      ]);
      if (res && res.id == this.reserva.id) {
        this.reserva.servicios = res.servicios;
      }
    },

    async onLimpiarProveedorServicio(item) {
      if (!item?.servicio) {
        return;
      }
      const servicioId = this.getIdServicioReserva(item.servicio);
      if (!servicioId) {
        return;
      }
      item.servicio.proveedor = null;
      item.servicio.proveedor_id = null;
      const res = await this.updateReservaServicioProveedor([this.access_token, servicioId, null]);
      if (res && res.id == this.reserva.id) {
        this.reserva.servicios = res.servicios;
      }
    },

    onInputFechaServicio(item, valor) {
      if (!item?.servicio) {
        return;
      }
      this.$set(item.servicio, "fecha", valor || null);
      this.$set(item, "_fechaServicioForzarVacio", false);
      this.$set(item, "_showFechaServicio", false);
      this.onGuardarFechaServicio(item);
    },

    async onGuardarFechaServicio(item) {
      if (!item?.servicio) {
        return;
      }
      const servicioId = this.getIdServicioReserva(item.servicio);
      if (!servicioId) {
        return;
      }
      const fecha = this.normalizarFechaServicio(this.getFechaServicioBase(item));
      const res = await this.updateReservaServicioFecha([this.access_token, servicioId, fecha]);
      if (res && res.id == this.reserva.id) {
        this.reserva.servicios = res.servicios;
      }
    },

    onLimpiarFechaServicio(item) {
      if (!item?.servicio) {
        return;
      }
      this.$set(item, "_fechaServicioForzarVacio", true);
      this.$set(item.servicio, "fecha", null);
      this.onGuardarFechaServicio(item);
    },

    getFechaServicioParaPicker(item) {
      return this.normalizarFechaServicio(this.getFechaServicioBase(item));
    },

    getFechaServicioMostrada(item) {
      const fecha = this.getFechaServicioParaPicker(item);
      return fecha ? formatearFechaCorta(fecha) : "";
    },

    getFechaServicioBase(item) {
      if (!item?.servicio) {
        return null;
      }
      if (item._fechaServicioForzarVacio) {
        return null;
      }
      return (
        item.servicio.fecha ||
        item.servicio.fecha_servicio ||
        item.servicio.fecha_inicio ||
        item.fecha ||
        null
      );
    },

    normalizarFechaServicio(fecha) {
      if (!fecha) {
        return null;
      }
      if (fecha instanceof Date) {
        if (Number.isNaN(fecha.getTime())) {
          return null;
        }
        return fecha.toISOString().slice(0, 10);
      }
      if (typeof fecha !== "string") {
        return null;
      }
      const valor = fecha.trim();
      if (!valor) {
        return null;
      }
      if (/^\d{4}-\d{2}-\d{2}/.test(valor)) {
        return valor.slice(0, 10);
      }
      const match = valor.match(/^(\d{2})[\/-](\d{2})[\/-](\d{4})$/);
      if (match) {
        const [, dia, mes, anio] = match;
        return `${anio}-${mes}-${dia}`;
      }
      return null;
    },

    getIdServicioReserva(servicio) {
      if (!servicio) {
        return null;
      }
      return servicio.id ?? servicio.reserva_servicio_id ?? servicio.servicio_id ?? null;
    },

    getIdReservaServicio(servicio) {
      if (!servicio) {
        return null;
      }
      return (
        servicio.id ??
        null
      );
    },

    getIdReservaEtapaProveedor(etapa) {
      if (!etapa?.pivot) {
        return null;
      }
      return etapa.pivot.id ?? null;
    },

    esProveedorRutasMeigas(proveedor) {
      const normalizar = (valor) => String(valor || "").trim().toUpperCase();
      return (
        normalizar(proveedor?.nombre_alias) === "RUTAS MEIGAS" ||
        normalizar(proveedor?.nombre) === "RUTAS MEIGAS"
      );
    },

    getProveedorPorDefecto(listado) {
      if (!Array.isArray(listado)) {
        return null;
      }
      return listado.find((proveedor) => this.esProveedorRutasMeigas(proveedor)) || null;
    },

    getProveedorSeleccionado(servicio, proveedores) {
      if (!servicio) {
        return null;
      }
      if (servicio.proveedor) {
        return servicio.proveedor;
      }
      const listado = Array.isArray(proveedores) ? proveedores : [];
      const proveedorId = servicio.proveedor_id;
      const proveedorNombre = servicio.proveedor_nombre;
      if (!proveedorId && !proveedorNombre) {
        const proveedorPorDefecto = this.getProveedorPorDefecto(listado);
        const proveedorAutoSeleccionado = proveedorPorDefecto || (listado.length === 1 ? listado[0] : null);
        if (!proveedorAutoSeleccionado) {
          return null;
        }
        servicio.proveedor = proveedorAutoSeleccionado;
        servicio.proveedor_id = proveedorAutoSeleccionado?.id ?? null;
        this.queueGuardarProveedorAuto(servicio);
        return proveedorAutoSeleccionado;
      }
      const encontrado = proveedorId
        ? listado.find((proveedor) => proveedor.id == proveedorId)
        : null;
      if (encontrado) {
        return encontrado;
      }
      return {
        id: proveedorId ?? null,
        nombre_alias: proveedorNombre || "",
      };
    },

    getProveedoresConSeleccionado(proveedores, proveedorSeleccionado) {
      const listado = Array.isArray(proveedores) ? proveedores : [];
      if (!proveedorSeleccionado) {
        return listado;
      }
      const existe = listado.some((proveedor) => proveedor.id == proveedorSeleccionado.id);
      if (existe) {
        return listado;
      }
      return [proveedorSeleccionado, ...listado];
    },

    queueGuardarProveedorAuto(servicio) {
      if (!servicio || servicio._proveedorAutoGuardado || servicio._proveedorAutoPendiente) {
        return;
      }
      servicio._proveedorAutoPendiente = true;
      this.$nextTick(async () => {
        if (servicio._proveedorAutoGuardado) {
          return;
        }
        await this.onGuardarProveedorServicio({ servicio });
        servicio._proveedorAutoGuardado = true;
        servicio._proveedorAutoPendiente = false;
      });
    },

    queueGuardarFechaAuto(item) {
      if (!item?.servicio || item.servicio._fechaAutoGuardada || item.servicio._fechaAutoPendiente) {
        return;
      }
      item.servicio._fechaAutoPendiente = true;
      this.$nextTick(async () => {
        if (item.servicio._fechaAutoGuardada) {
          return;
        }
        await this.onGuardarFechaServicio(item);
        item.servicio._fechaAutoGuardada = true;
        item.servicio._fechaAutoPendiente = false;
      });
    },

    addServiciosAgregadosDeTraslados(servicios, filas) {
      const listado = Array.isArray(servicios) ? servicios : [];
      const prefijos = [
        "Traslado privado",
        "Traslados extra",
        "Private transfer",
        "Extra transfer",
        "Privater transfer",
        "Zusätzliche transfer",
      ];
      const fechaReserva = formatearFechaCorta(this.reserva.fecha_inicio);

      listado
        .filter((servicio) => {
          const titulo = (servicio?.titulo || "").toLowerCase().trim();
          if (!titulo) {
            return false;
          }
          if (servicio?.esta_incluido != 0) {
            return false;
          }
          return prefijos.some((prefijo) => titulo.startsWith(prefijo.toLowerCase()));
        })
        .forEach((servicio) => {
          const proveedorSeleccionado = this.getProveedorSeleccionado(
            servicio,
            this.proveedoresServiciosTransfers
          );
          if (proveedorSeleccionado) {
            servicio.proveedor = proveedorSeleccionado;
          }
          const fechaServicio = servicio?.fecha || servicio?.fecha_servicio || servicio?.fecha_inicio;
          const fecha = fechaServicio ? formatearFechaCorta(fechaServicio) : fechaReserva;
          filas.push({
            fecha,
            alojamiento: "Proveedor:",
            proveedores_servicio: this.getProveedoresConSeleccionado(
              this.proveedoresServiciosTransfers,
              proveedorSeleccionado
            ),
            descripcion: servicio?.titulo || "",
            esServicio: true,
            mostrarAcciones: true,
            fechaEditable: true,
            venta: "0.00 €",
            coste: servicio?.coste ?? "0",
            servicio,
          });
        });
    },

    addServiciosAgregadosDeExcursiones(servicios, filas) {
      const prefijosExc = ["Excursión", "One day tour", "Tagestour"];
      const fechaReservaExc = formatearFechaCorta(this.reserva.fecha_llegada);

      const listado = Array.isArray(servicios) ? servicios : [];
      const prefijos = Array.isArray(prefijosExc) ? prefijosExc : [];
      const fechaReserva = fechaReservaExc || "";

      listado
        .filter((servicio) => {
          const titulo = (servicio?.titulo || "").toLowerCase().trim();
          if (!titulo) {
            return false;
          }
          if (servicio?.esta_incluido != 0) {
            return false;
          }
          return prefijos.some((prefijo) => titulo.startsWith(prefijo.toLowerCase()));
        })
        .forEach((servicio) => {
          const proveedorSeleccionado = this.getProveedorSeleccionado(
            servicio,
            this.proveedoresServiciosExcursiones
          );
          if (proveedorSeleccionado) {
            servicio.proveedor = proveedorSeleccionado;
          }
          const fechaServicio = servicio?.fecha || servicio?.fecha_servicio || servicio?.fecha_inicio;
          const fechaBase =
            fechaServicio || null;
          if (!fechaServicio && fechaBase) {
            servicio.fecha = fechaBase;
          }
          const fecha = fechaServicio ? formatearFechaCorta(fechaServicio) : null;
          const item = {
            fecha,
            alojamiento: "Proveedor:",
            proveedores_servicio: this.getProveedoresConSeleccionado(
              this.proveedoresServiciosExcursiones,
              proveedorSeleccionado
            ),
            descripcion: servicio?.titulo || "",
            esServicio: true,
            mostrarAcciones: true,
            fechaEditable: true,
            venta: "0.00 €",
            coste: servicio?.coste ?? "0",
            servicio,
          };
          filas.push(item);
          if (!fechaServicio && fechaBase) {
            this.queueGuardarFechaAuto(item);
          }
        });
    },

    addServiciosAgregadosDeSeguro(servicios, filas) {
      const prefijosExc = ["Seguro de cancelación", "Travel cancellation", "Reiserücktrittsversicherung"];
      const fechaReservaExc = formatearFechaCorta(this.reserva.fecha_llegada);

      const listado = Array.isArray(servicios) ? servicios : [];
      const prefijos = Array.isArray(prefijosExc) ? prefijosExc : [];
      const fechaReserva = fechaReservaExc || "";

      listado
        .filter((servicio) => {
          const titulo = (servicio?.titulo || "").toLowerCase().trim();
          if (!titulo) {
            return false;
          }
          if (servicio?.esta_incluido != 0) {
            return false;
          }
          return prefijos.some((prefijo) => titulo.startsWith(prefijo.toLowerCase()));
        })
        .forEach((servicio) => {
          const proveedorSeleccionado = this.getProveedorSeleccionado(
            servicio,
            this.proveedoresServiciosSeguros
          );
          if (proveedorSeleccionado) {
            servicio.proveedor = proveedorSeleccionado;
          }
          const fechaServicio = servicio?.fecha || servicio?.fecha_servicio || servicio?.fecha_inicio;
          const fecha = fechaServicio ? formatearFechaCorta(fechaServicio) : fechaReserva;
          filas.push({
            fecha,
            alojamiento: "Proveedor:",
            proveedores_servicio: this.getProveedoresConSeleccionado(
              this.proveedoresServiciosSeguros,
              proveedorSeleccionado
            ),
            descripcion: servicio?.titulo || "",
            esServicio: true,
            mostrarAcciones: true,
            venta: "0.00 €",
            coste: servicio?.coste ?? "0",
            servicio,
          });
        });
    },

    addServiciosAgregadosDeServiciosExtra(servicios, filas) {
      const prefijosExc = ["Servicios extra", "Extra services", "Zusatzleistungen"];
      const fechaReservaExc = formatearFechaCorta(this.reserva.fecha_llegada);

      const listado = Array.isArray(servicios) ? servicios : [];
      const prefijos = Array.isArray(prefijosExc) ? prefijosExc : [];
      const fechaReserva = fechaReservaExc || "";

      listado
        .filter((servicio) => {
          const titulo = (servicio?.titulo || "").toLowerCase().trim();
          if (!titulo) {
            return false;
          }
          if (servicio?.esta_incluido != 0) {
            return false;
          }
          return prefijos.some((prefijo) => titulo.startsWith(prefijo.toLowerCase()));
        })
        .forEach((servicio) => {
          const fechaServicio = servicio?.fecha || servicio?.fecha_servicio || servicio?.fecha_inicio;
          const fecha = fechaServicio ? formatearFechaCorta(fechaServicio) : fechaReserva;
          filas.push({
            fecha,
            alojamiento: "Proveedor:",
            proveedores_servicio: servicio?.proveedor_nota || "",
            descripcion: servicio?.titulo + ' - ' + (servicio?.descripcion || ""),
            esServicio: true,
            esServicioExtra: true,
            mostrarAcciones: true,
            fechaEditable: true,
            venta: "0.00 €",
            coste: servicio?.coste ?? "0",
            servicio,
          });
        });
    },



    getFechasServicioTraslado(reserva) {
      const fechaInicioDate = new Date(reserva.fecha_inicio);
      const fechaLlegadaDate = new Date(reserva.fecha_llegada);
      if (!Number.isNaN(fechaInicioDate.getTime())) {
        fechaInicioDate.setDate(fechaInicioDate.getDate() + 1);
      }

      if (!Number.isNaN(fechaLlegadaDate.getTime())) {
        fechaLlegadaDate.setDate(fechaLlegadaDate.getDate() - 1);
      }

      const fechaInicio = formatearFechaCorta(fechaInicioDate);
      const fechaLlegada = formatearFechaCorta(fechaLlegadaDate);
      return `${fechaInicio} - ${fechaLlegada}`;
    },
  },
};
</script>

<style scoped>
.alternating-rows>>>tbody tr:nth-child(even) {
  background-color: #ebebeb !important;
}
.bordered-table>>>table {
  border-collapse: collapse;
}
.bordered-table>>>th,
.bordered-table>>>td {
  border: 1px solid #d0d0d0;
}
.bordered-table>>>.actions-column {
  width: 1%;
  white-space: nowrap;
}
.coste-text-field>>>input {
  text-align: right;
}
</style>
